import {useCallback, useState} from 'react';
import {questionGenerateQuestionGraphJson} from '../../api/callable/question';

export function useGenerateQuestionGraphJson() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const generateQuestionGraphJson = useCallback(
    async (
      questionText: string,
      topic?: string,
      difficulty?: number,
      hint?: string,
      options?: string[],
      answer?: string,
      explanation?: string,
    ): Promise<string | null> => {
      setLoading(true);
      setError(undefined);
      try {
        return await questionGenerateQuestionGraphJson({
          questionText,
          topic,
          difficulty,
          hint,
          options,
          answer,
          explanation,
        });
      } catch (err) {
        const e = err instanceof Error ? err : new Error(String(err));
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    generateQuestionGraphJson,
    loading,
    error,
  };
}
